import { Component, ViewEncapsulation, OnInit, Inject } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from './app.service';
import { TravelersService } from './components/travelers/travelers.service';
import { DOCUMENT } from '@angular/common';
import { ONBOARD_CONSTANTS } from './app.constants';
import { UtilService } from './util.service';
import * as MiscLib from '@flysas/misc-lib';
import { SharedService } from '@flysas/payment';
import { AuthService } from '@auth0/auth0-angular';
//import { Auth0Client } from '@auth0/auth0-spa-js';
import jwt_decode from "jwt-decode";
declare let $: any;
@Component({
  selector: 'app-onboard',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {


  currentState = '';
  showCustomerLanding = true;
  private subscription: Subscription;
  public isSplLanguage: boolean;
  public cookieBar: any;
  optionsApiResolved = false;
  accessToken:any;

  constructor(
    private translate: TranslateService,
    private appService: AppService,
    private travelersService: TravelersService,
    private utilService: UtilService, 
    private sharedService: SharedService,
    private auth: AuthService,
    //private auth0: Auth0Client,
    @Inject(DOCUMENT) private document: any
  ) {
    //this.handleRedirect();
    //console.log('app component In');

    if(sessionStorage.getItem('isAuthenticated') == 'true') {
      this.getAccessToken();
    }

    this.showLandingCustomer();
    this.loadGTMScripts();
    this.sharedService.getPaymentOptionsOutput$.subscribe(paymentOptionsOutput => {
      if (paymentOptionsOutput.selectedGroup !== undefined || paymentOptionsOutput.selectedMethod !== undefined) {
        this.optionsApiResolved = true;
      }
    });
  }

  ngOnInit() {

    if (ONBOARD_CONSTANTS.ENABLE_DEVICE_TOKEN_STRIPPING) {
      this.checkIfHomeURLHavingDeviceToken();
      //this.checkIfVoucherURLHavingDeviceToken();
    }
    const locale = window.location.pathname.split('/')[1];
    this.appService.getDeviceToken();
    this.appService.setAppLanguage(locale);
    this.appService.setAppPOS(locale);
    this.utilService.initiateUtilLib(this.appService.getPOS());
    this.translate.setDefaultLang(this.appService.getDefaultLanguage());
    this.translate.use(this.appService.getLanguage());
    this.translate.get('sasOnboard').subscribe((result: string) => {
      window.document.title = result;
    });
    this.isSplLanguage = ONBOARD_CONSTANTS.SPECIAL_LANGUAGE.indexOf(this.appService.getLanguage()) > -1;
    if (this.isSplLanguage) {
      this.document.getElementById('fonts').setAttribute('href', './assets/styles/fonts-market.css');
    }
    this.getTnCUrls();
    this.appService.checkOnboardIpRange();
    this.appService.setOnboardVisitedFlag();
    this.appService.setFlagClassToMarketSelector();
    if (this.appService.showCookieBar()) {
      setTimeout(() => { this.showCookieBar(); }, 1000);
    }
    if (this.appService.enableNewHeader) {
      this.getHeaderFooterScript();
    }
    this.appService.setFavicon();
    if (ONBOARD_CONSTANTS.ENABLE_DEVICE_TOKEN_STRIPPING) {
      setTimeout(() => { this.removeDeviceToken(); }, 7200000);
    }

  }

  async getAccessToken() {
    try {
      // Get the access token silently
      await this.auth.getAccessTokenSilently().subscribe(token => {
        //console.log('access_token subscribed: ', token);
        this.accessToken = token;
        let resultToken: any = jwt_decode(token);
        //console.log('Res Token: ', resultToken);
        const expiresAt = JSON.stringify(1000000 + new Date().getTime());
        sessionStorage.setItem('sessionId', resultToken.sessionId);
        sessionStorage.setItem('access_token', this.accessToken);
        sessionStorage.setItem('expires_At', expiresAt);
        localStorage.setItem('ebLogin', 'true');
      });
    } catch (error) {
      console.error('Error getting access token:', error);
    }
  }

  removeDeviceToken() {
    if (sessionStorage.getItem('deviceToken') && sessionStorage.getItem('deviceToken') !== '') {
      sessionStorage.removeItem('deviceToken');
    }
  }

  checkIfHomeURLHavingDeviceToken() {
    if (window.location.href.search('home') !== -1 && window.location.href.search('deviceToken') !== -1) {
      window.location.href = ONBOARD_CONSTANTS.REDIRECTION_URL;
    }
  }

  checkIfVoucherURLHavingDeviceToken() {
    if (window.location.href.search('home/voucher') !== -1 && window.location.href.search('deviceToken') !== -1) {
      window.location.href = ONBOARD_CONSTANTS.REDIRECTION_URL;
    }
  }

  getTnCUrls() {
    const tncUrls = { sas: '', viasat: '' };
    const baseUrl = this.appService.getTncBaseUrl();
    this.translate.get(['sasTnC.text', 'viasatTnC.text']).subscribe(result => {
      tncUrls.sas = baseUrl + result['sasTnC.text'];
      tncUrls.viasat = baseUrl + result['viasatTnC.text'];
      this.travelersService.setTnCUrls(tncUrls);
    });
  }

  private showLandingCustomer() {
    this.subscription = this.appService.landingCustomerObservable.subscribe(
      value => { setTimeout(() => { this.showCustomerLanding = value; }, 0); });
  }

  public showCookieBar() {
    if (!this.cookieBar) {
      this.translate.get([`'cookie.accept', 'cookie.description', 'cookie.policy.linktext',
        'cookie.policyUrl.' ${this.appService.getLanguage().toLowerCase()}`]).subscribe(result => {
          this.cookieBar = new MiscLib.Misc('#cookieBar', {
            market: this.appService.getPOS,
            lang: this.appService.getLanguage(),
            translation: {
              'accept': result['cookie.accept'],
              'description': result['cookie.description'],
              'linktext': result['cookie.policy.linktext'],
              'policyUrl': result['cookie.policyUrl.' + this.appService.getPOS().toLowerCase()]
            }
          });
          this.cookieBar.showCookie();
        });
    }
  }

  public loadGTMScripts() {
    const gtm = document.createElement('script');
    const baseUrl = `https://${window.location.hostname}/`;
    gtm.type = 'text/javascript';
    gtm.src = baseUrl + 'onboard/assets/scripts/gtm-initializer.js';
    $('head').append(gtm);
  }

  public getHeaderFooterScript() {
    $.getScript('/etc/clientlibs/flysas/header-footer.js', () => {
         // This is intentional
    });
  }
}
